import { useMutation } from "react-query";

export const useSmartMutation = (mutationKey, mutationFn, { onSuccess, onError, zustandSetter } = {}) => {
  return useMutation(mutationKey, mutationFn, {
    onSuccess: (data, variables, context) => {
      if (typeof zustandSetter === "function") {
        zustandSetter(data); // original behavior
      } else if (zustandSetter?.setter && zustandSetter?.path) {
        const value = getNested(data, zustandSetter.path);
        zustandSetter.setter(value);
      }

      // zustandSetter?.(data);
      onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      console.error("SmartMutation Error:", error);
      onError?.(error, variables, context);
    },
  });
};

const getNested = (obj, path) => {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
};
